import { render, staticRenderFns } from "./Singpass.vue?vue&type=template&id=550b955d&"
import script from "./Singpass.vue?vue&type=script&lang=js&"
export * from "./Singpass.vue?vue&type=script&lang=js&"
import style0 from "./Singpass.vue?vue&type=style&index=0&id=550b955d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports